export default defineNuxtRouteMiddleware((to, from) => {
    const authStore = useAuthStore()

    const skipeRoutes = ['/auth/verify-email']

    if (authStore.token && to.path.startsWith('/auth')) {

        /**
         * Skip some routes
         */
        if (skipeRoutes.some(route => to.path.includes(route))) {
            return true;
        }

        return navigateTo('/conversations')
    }
})